export default "__VITE_ASSET__dd94d447__"